import { Skeleton } from 'design-system';

import { Z_INDEX } from '@/config/z-index';
import { MarketWidgetsSkeleton } from '@/features/markets';

export const DashboardSkeleton = () => (
  <section
    className='w-full'
    data-testid='dashboard-skeleton'
  >
    <output
      aria-busy='true'
      aria-label='Loading dashboard'
      className='sr-only'
    >
      Loading dashboard
    </output>
    <div
      aria-hidden='true'
      data-testid='dashboard-skeleton-visual'
    >
      <header
        className='sticky -top-6 flex min-w-0 items-center gap-2 bg-background py-6'
        data-testid='dashboard-header-skeleton'
        style={{ zIndex: Z_INDEX.floatingAnchor }}
      >
        <Skeleton className='h-8 w-40 shrink-0' />
        <div className='flex min-w-0 flex-1 items-center gap-1 overflow-hidden'>
          <Skeleton className='h-8 w-36 shrink-0' />
          <Skeleton className='h-8 w-32 shrink-0' />
        </div>
        <Skeleton className='ml-auto h-9 w-48 shrink-0' />
      </header>
      <main className='flex grow flex-col gap-6'>
        <MarketWidgetsSkeleton />
      </main>
    </div>
  </section>
);
